import _ from 'lodash';
import React, { useState } from 'react';
import styles from './index.module.scss';

const OrderProduct = (props) => {
  const { orderItem, key } = props;
  const [isImageOpen, setIsImageOpen] = useState(false);

  const openFullScreenImage = () => {
    setIsImageOpen(true);
  };

  const closeFullScreenImage = () => {
    setIsImageOpen(false);
  };

  const onClickFullScreenImage = (e) => {
    e.stopPropagation();
  };

  const getPackagingType = () => {
    const packagingType = _.get(orderItem, 'item.packagingType', '');
    if(packagingType){
      return(
        <div>
          <span className={styles['packagingTypeHeading']}>Packaging Type:</span>
          <span className={styles['packagingType']}>&nbsp;{orderItem?.item?.packagingType}</span>
        </div>
      );
    }
    return null;
  };

  return (
    <div className={styles['order-item-container']} key={key}>
      <div className="d-flex align-items-center">
        {isImageOpen ? (
          <div
            onClick={closeFullScreenImage}
            className={`${styles['lightbox']} ${styles['show']} relative`}
          >
            <img
              onClick={onClickFullScreenImage}
              className={styles['show_image']}
              src={orderItem?.item?.image}
            />
            <span
              className={styles['close-icon']}
              onClick={closeFullScreenImage}
            >
              <i className="fa fa-times-circle"></i>
            </span>
          </div>
        ) : (
          <img
            className={styles['product-image']}
            onClick={openFullScreenImage}
            src={orderItem?.item?.image}
          />
        )}
        <div>
          <span className={styles['name']}>{orderItem?.item?.enName}</span>
          {getPackagingType()}
        </div>
      </div>
      <span>x{orderItem?.count}</span>
    </div>
  );
};

export default OrderProduct;
